import Glide from '@glidejs/glide'
export default class Slider{

    constructor(element) {
        this.$wrapper = element;
        this.$glideWrapper = this.$wrapper.querySelectorAll('.js-slider-glide');
        this.$left = this.$wrapper.querySelectorAll('.js-slider-left')[0];
        this.$right = this.$wrapper.querySelectorAll('.js-slider-right')[0];
        this.init();
        this.bindEvents()
    }

    bindEvents(){
        this.$left.addEventListener('click', this.goBackward.bind(this));
        this.$right.addEventListener('click', this.goForward.bind(this));
    }

    init(){
        this.glide = new Glide(this.$glideWrapper[0], {
            perView:3,
            gap:30,
            bound:true,
            breakpoints: {
                900: {
                    perView: 2
                },
                700: {
                    perView: 1
                }
            }
        }).mount();
    }

    goForward(){
        this.glide.go('>');
    }

    goBackward(){
        this.glide.go('<');
    }



}